// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchSettingsForm-space1-fFYBC {
	margin-bottom: 6px !important;
}

.SearchSettingsForm-space2-F9DLO {
	margin-bottom: 12px !important;
}

.SearchSettingsForm-space3-edh1j {
	margin-bottom: 18px !important;
}

.SearchSettingsForm-space4-rYxbZ {
	margin-bottom: 24px !important;
}

.SearchSettingsForm-space5-k09tS {
	margin-bottom: 30px !important;
}

.SearchSettingsForm-space6-r2UcL {
	margin-bottom: 36px !important;
}

.SearchSettingsForm-space7-AHAgZ {
	margin-bottom: 42px !important;
}

.SearchSettingsForm-space8-NF7Dp {
	margin-bottom: 48px !important;
}

.SearchSettingsForm-spaceTop1-SnY97 {
	margin-top: 6px !important;
}

.SearchSettingsForm-spaceTop2-EYexq {
	margin-top: 12px !important;
}

.SearchSettingsForm-spaceTop3-qtKse {
	margin-top: 18px !important;
}

.SearchSettingsForm-spaceTop4-XMRvo {
	margin-top: 24px !important;
}

.SearchSettingsForm-spaceTop5-Wm6pB {
	margin-top: 30px !important;
}

.SearchSettingsForm-spaceTop6-nqCze {
	margin-top: 36px !important;
}

.SearchSettingsForm-spaceTop7-zsmSY {
	margin-top: 42px !important;
}

.SearchSettingsForm-spaceTop8-zhBwC {
	margin-top: 48px !important;
}

.SearchSettingsForm-noMargin-d815y {
	margin: 0px !important;
}

.SearchSettingsForm-padding1-lRmw8 {
	padding-bottom: 6px !important;
}

.SearchSettingsForm-padding2-vFwDI {
	padding-bottom: 12px !important;
}

.SearchSettingsForm-padding3-qQChb {
	padding-bottom: 18px !important;
}

.SearchSettingsForm-padding4-i5ozR {
	padding-bottom: 24px !important;
}

.SearchSettingsForm-padding5-YbD4d {
	padding-bottom: 30px !important;
}

.SearchSettingsForm-padding6-GASH1 {
	padding-bottom: 36px !important;
}

.SearchSettingsForm-padding7-S9geR {
	padding-bottom: 42px !important;
}

.SearchSettingsForm-paddingTop1-Y4I8w {
	padding-top: 6px !important;
}

.SearchSettingsForm-paddingTop2-KAYOm {
	padding-top: 12px !important;
}

.SearchSettingsForm-paddingTop3-bzdGY {
	padding-top: 18px !important;
}

.SearchSettingsForm-paddingTop4-IUMr7 {
	padding-top: 24px !important;
}

.SearchSettingsForm-paddingTop5-kj4_s {
	padding-top: 30px !important;
}

.SearchSettingsForm-paddingTop6-UbyIL {
	padding-top: 36px !important;
}

.SearchSettingsForm-paddingTop7-lv2qd {
	padding-top: 42px !important;
}

.SearchSettingsForm-noPadding-UaMuO {
	padding: 0px !important;
}

.SearchSettingsForm-spaceMarginBottom0-m3s5Z {
	margin-bottom: 0;
}

.SearchSettingsForm-textBold-acKil {
	font-weight: 500 !important;
}

.SearchSettingsForm-textBolder-YvE38 {
	font-weight: 700 !important;
}

.SearchSettingsForm-textNormal-F4vjL {
	font-weight: normal !important;
}

/*New Design Text Colors */

.SearchSettingsForm-textDarkBlue-hmCDI {
	color: rgb(20, 39, 94) !important;
}

.SearchSettingsForm-textLightBlue-W5WPl {
	color: rgb(57, 87, 106) !important;
}

.SearchSettingsForm-textLightSandleGreen-f6VFT {
	color: rgb(76, 86, 41) !important;
}

.SearchSettingsForm-textLightBrown-a0ZbU {
	color: rgb(115, 79, 33) !important;
}

.SearchSettingsForm-textMediumMaroon-Ter3b {
	color: rgb(87, 37, 51) !important;
}

.SearchSettingsForm-textBrown-NG__M {
	color: rgb(160, 47, 24) !important;
}

.SearchSettingsForm-textMaroon-t8VLO {
	color: rgb(155, 49, 67) !important;
}

.SearchSettingsForm-textDarkBrown-unLLi {
	color: rgb(83, 18, 16) !important;
}

.SearchSettingsForm-textMediumBrown-xeBvq {
	color: rgb(142, 28, 10) !important;
}

.SearchSettingsForm-textSkyBlue-BEvNt {
	color: rgb(37, 117, 141) !important;
}

.SearchSettingsForm-textGray-RAx3S {
	color: rgb(77, 65, 51) !important;
}

.SearchSettingsForm-errorMessage-vRq6F {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.SearchSettingsForm-userText-U3niz {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.SearchSettingsForm-panelHeader-AgndP {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.SearchSettingsForm-exportSection-gtbdc {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.SearchSettingsForm-exportSectionGridSub-Swuqn {
	grid-template-columns: 50% 49% !important;
}

.SearchSettingsForm-exportText-rOMfS {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.SearchSettingsForm-exportLinkImg-ClLXC {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.SearchSettingsForm-exportImg-D6mxo {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.SearchSettingsForm-linkBtn-sPT5R {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.SearchSettingsForm-table-MypbR {
	display: table;
}

.SearchSettingsForm-tableRow-IaEn3 {
	display: table-row;
}

.SearchSettingsForm-tableCell-EcY_A {
	display: table-cell;
	float: none;
}

.SearchSettingsForm-formGroup-iv1wm {
	margin-bottom: 6px;
}

.SearchSettingsForm-marginTop0-B37al {
	margin-top: 0;
}

.SearchSettingsForm-marginBottom20-yqpOb {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.SearchSettingsForm-bannerImageBg-bjqYG {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.SearchSettingsForm-bannerDelete-TTfyF {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.SearchSettingsForm-exportLink-aTZKW {
	padding-top: 10px;
	padding-right: 10px;
}

.SearchSettingsForm-seachContent-RbB4p {
	padding-left: 0px;
	margin-bottom: 5px;
}

.SearchSettingsForm-marginBottom9-XRv1H {
	margin-bottom: 9px;
}

.SearchSettingsForm-spaceTop52-VJ6qK {
	margin-top: 52px;
}

.SearchSettingsForm-profileViewInner-mOfKN {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.SearchSettingsForm-profileViewMain-q5qBO {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.SearchSettingsForm-profileViewlabel-H0WkD {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.SearchSettingsForm-profileViewMainContent-tnsGY {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.SearchSettingsForm-reviewsFormStar-oU15I {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.SearchSettingsForm-reviewsFormStar-oU15I svg {
	cursor: pointer;
}

.SearchSettingsForm-addLanguageText-GBZYw {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.SearchSettingsForm-exportSection-gtbdc {
		grid-template-columns: 100%;
	}

	.SearchSettingsForm-spaceTop52-VJ6qK {
		margin-top: 18px;
	}

	.SearchSettingsForm-exportText-rOMfS {
		float: none;
		margin-top: 12px;
	}

	.SearchSettingsForm-exportSectionGridSub-Swuqn {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.SearchSettingsForm-profileViewlabel-H0WkD {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.SearchSettingsForm-profileViewMainContent-tnsGY {
		width: 100%;
		text-align: center;
	}

	.SearchSettingsForm-panelHeader-AgndP {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `SearchSettingsForm-space1-fFYBC`,
	"space2": `SearchSettingsForm-space2-F9DLO`,
	"space3": `SearchSettingsForm-space3-edh1j`,
	"space4": `SearchSettingsForm-space4-rYxbZ`,
	"space5": `SearchSettingsForm-space5-k09tS`,
	"space6": `SearchSettingsForm-space6-r2UcL`,
	"space7": `SearchSettingsForm-space7-AHAgZ`,
	"space8": `SearchSettingsForm-space8-NF7Dp`,
	"spaceTop1": `SearchSettingsForm-spaceTop1-SnY97`,
	"spaceTop2": `SearchSettingsForm-spaceTop2-EYexq`,
	"spaceTop3": `SearchSettingsForm-spaceTop3-qtKse`,
	"spaceTop4": `SearchSettingsForm-spaceTop4-XMRvo`,
	"spaceTop5": `SearchSettingsForm-spaceTop5-Wm6pB`,
	"spaceTop6": `SearchSettingsForm-spaceTop6-nqCze`,
	"spaceTop7": `SearchSettingsForm-spaceTop7-zsmSY`,
	"spaceTop8": `SearchSettingsForm-spaceTop8-zhBwC`,
	"noMargin": `SearchSettingsForm-noMargin-d815y`,
	"padding1": `SearchSettingsForm-padding1-lRmw8`,
	"padding2": `SearchSettingsForm-padding2-vFwDI`,
	"padding3": `SearchSettingsForm-padding3-qQChb`,
	"padding4": `SearchSettingsForm-padding4-i5ozR`,
	"padding5": `SearchSettingsForm-padding5-YbD4d`,
	"padding6": `SearchSettingsForm-padding6-GASH1`,
	"padding7": `SearchSettingsForm-padding7-S9geR`,
	"paddingTop1": `SearchSettingsForm-paddingTop1-Y4I8w`,
	"paddingTop2": `SearchSettingsForm-paddingTop2-KAYOm`,
	"paddingTop3": `SearchSettingsForm-paddingTop3-bzdGY`,
	"paddingTop4": `SearchSettingsForm-paddingTop4-IUMr7`,
	"paddingTop5": `SearchSettingsForm-paddingTop5-kj4_s`,
	"paddingTop6": `SearchSettingsForm-paddingTop6-UbyIL`,
	"paddingTop7": `SearchSettingsForm-paddingTop7-lv2qd`,
	"noPadding": `SearchSettingsForm-noPadding-UaMuO`,
	"spaceMarginBottom0": `SearchSettingsForm-spaceMarginBottom0-m3s5Z`,
	"textBold": `SearchSettingsForm-textBold-acKil`,
	"textBolder": `SearchSettingsForm-textBolder-YvE38`,
	"textNormal": `SearchSettingsForm-textNormal-F4vjL`,
	"textDarkBlue": `SearchSettingsForm-textDarkBlue-hmCDI`,
	"textLightBlue": `SearchSettingsForm-textLightBlue-W5WPl`,
	"textLightSandleGreen": `SearchSettingsForm-textLightSandleGreen-f6VFT`,
	"textLightBrown": `SearchSettingsForm-textLightBrown-a0ZbU`,
	"textMediumMaroon": `SearchSettingsForm-textMediumMaroon-Ter3b`,
	"textBrown": `SearchSettingsForm-textBrown-NG__M`,
	"textMaroon": `SearchSettingsForm-textMaroon-t8VLO`,
	"textDarkBrown": `SearchSettingsForm-textDarkBrown-unLLi`,
	"textMediumBrown": `SearchSettingsForm-textMediumBrown-xeBvq`,
	"textSkyBlue": `SearchSettingsForm-textSkyBlue-BEvNt`,
	"textGray": `SearchSettingsForm-textGray-RAx3S`,
	"errorMessage": `SearchSettingsForm-errorMessage-vRq6F`,
	"userText": `SearchSettingsForm-userText-U3niz`,
	"panelHeader": `SearchSettingsForm-panelHeader-AgndP`,
	"exportSection": `SearchSettingsForm-exportSection-gtbdc`,
	"exportSectionGridSub": `SearchSettingsForm-exportSectionGridSub-Swuqn`,
	"exportText": `SearchSettingsForm-exportText-rOMfS`,
	"exportLinkImg": `SearchSettingsForm-exportLinkImg-ClLXC`,
	"exportImg": `SearchSettingsForm-exportImg-D6mxo`,
	"linkBtn": `SearchSettingsForm-linkBtn-sPT5R`,
	"table": `SearchSettingsForm-table-MypbR`,
	"tableRow": `SearchSettingsForm-tableRow-IaEn3`,
	"tableCell": `SearchSettingsForm-tableCell-EcY_A`,
	"formGroup": `SearchSettingsForm-formGroup-iv1wm`,
	"marginTop0": `SearchSettingsForm-marginTop0-B37al`,
	"marginBottom20": `SearchSettingsForm-marginBottom20-yqpOb`,
	"bannerImageBg": `SearchSettingsForm-bannerImageBg-bjqYG`,
	"bannerDelete": `SearchSettingsForm-bannerDelete-TTfyF`,
	"exportLink": `SearchSettingsForm-exportLink-aTZKW`,
	"seachContent": `SearchSettingsForm-seachContent-RbB4p`,
	"marginBottom9": `SearchSettingsForm-marginBottom9-XRv1H`,
	"spaceTop52": `SearchSettingsForm-spaceTop52-VJ6qK`,
	"profileViewInner": `SearchSettingsForm-profileViewInner-mOfKN`,
	"profileViewMain": `SearchSettingsForm-profileViewMain-q5qBO`,
	"profileViewlabel": `SearchSettingsForm-profileViewlabel-H0WkD`,
	"profileViewMainContent": `SearchSettingsForm-profileViewMainContent-tnsGY`,
	"reviewsFormStar": `SearchSettingsForm-reviewsFormStar-oU15I`,
	"addLanguageText": `SearchSettingsForm-addLanguageText-GBZYw`
};
module.exports = ___CSS_LOADER_EXPORT___;
